import { ref, watch, onBeforeUnmount } from 'vue';

const SHOW_DELAY_MS = 500;
const HIDE_DELAY_MS = 200;

export const useEventHoverCard = ({
  enabled,
  blocked,
  anchorRef,
  onHoverStart,
  onHoverEnd,
}) => {
  const showHoverCard = ref(false);
  const hoverAnchorRect = ref(null);
  let hoverShowTimer = null;
  let hoverHideTimer = null;

  const clearHoverTimers = () => {
    clearTimeout(hoverShowTimer);
    clearTimeout(hoverHideTimer);
    hoverShowTimer = null;
    hoverHideTimer = null;
  };

  const hideHoverCard = () => {
    clearHoverTimers();
    showHoverCard.value = false;
    onHoverEnd?.();
  };

  const onEscapeKey = event => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    hideHoverCard();
  };

  const startHoverCard = () => {
    if (!enabled.value || blocked.value) return;
    clearHoverTimers();
    onHoverStart?.();
    hoverShowTimer = setTimeout(() => {
      if (!enabled.value || blocked.value) return;
      hoverAnchorRect.value = anchorRef.value?.getBoundingClientRect() || null;
      showHoverCard.value = true;
    }, SHOW_DELAY_MS);
  };

  const hideHoverCardSoon = () => {
    clearHoverTimers();
    hoverHideTimer = setTimeout(() => {
      showHoverCard.value = false;
      onHoverEnd?.();
    }, HIDE_DELAY_MS);
  };

  const keepHoverCard = () => {
    clearHoverTimers();
    showHoverCard.value = true;
  };

  watch(showHoverCard, isOpen => {
    if (isOpen) {
      window.addEventListener('keydown', onEscapeKey);
    } else {
      window.removeEventListener('keydown', onEscapeKey);
    }
  });

  watch(blocked, isBlocked => {
    if (isBlocked) hideHoverCard();
  });

  watch(enabled, isEnabled => {
    if (!isEnabled) hideHoverCard();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEscapeKey);
    hideHoverCard();
  });

  return {
    showHoverCard,
    hoverAnchorRect,
    startHoverCard,
    hideHoverCardSoon,
    keepHoverCard,
    hideHoverCard,
  };
};
